(() => {
  const selector = '[data-oz-resource-hub]';

  const init = (hub) => {
    if (hub.oztechResourceController) return;
    const controller = new AbortController();
    const { signal } = controller;
    const input = hub.querySelector('[data-oz-resource-search]');
    const familyButtons = [...hub.querySelectorAll('[data-oz-family-filters] [data-oz-filter]')];
    const typeButtons = [...hub.querySelectorAll('[data-oz-type-filters] [data-oz-filter]')];
    const items = [...hub.querySelectorAll('[data-oz-resource-item]')];
    const groups = [...hub.querySelectorAll('[data-oz-resource-group]')];
    const count = hub.querySelector('[data-oz-resource-count]');
    const empty = hub.querySelector('[data-oz-resource-empty]');
    const filterStatus = hub.querySelector('[data-oz-filter-status]');
    const activeFilters = hub.querySelector('[data-oz-active-filters]');
    const clearButtons = [...hub.querySelectorAll('[data-oz-clear-filters]')];
    let family = 'all';
    let type = 'all';

    const selectFilter = (buttons, selected) => {
      buttons.forEach((button) => {
        const active = button.dataset.ozFilter === selected;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    const update = () => {
      const query = (input?.value || '').trim().toLowerCase();
      const hasActiveFilters = Boolean(query) || family !== 'all' || type !== 'all';
      let visible = 0;

      items.forEach((item) => {
        const families = (item.dataset.family || '').split(/\s+/);
        const searchable = (item.dataset.search || '').toLowerCase();
        const familyMatch = family === 'all' || families.includes(family);
        const typeMatch = type === 'all' || item.dataset.resourceType === type;
        const searchMatch = !query || searchable.includes(query);
        const show = familyMatch && typeMatch && searchMatch;
        item.hidden = !show;
        if (show) visible += 1;
      });

      groups.forEach((group) => {
        group.hidden = !group.querySelector('[data-oz-resource-item]:not([hidden])');
      });
      if (count) count.textContent = `${visible} resource${visible === 1 ? '' : 's'} shown`;
      if (empty) empty.hidden = visible !== 0;
      if (filterStatus) filterStatus.hidden = !hasActiveFilters;
      if (activeFilters) {
        const labels = [];
        if (query) labels.push(`Search: “${input.value.trim()}”`);
        if (family !== 'all') labels.push(`Family: ${familyButtons.find((button) => button.dataset.ozFilter === family)?.textContent.trim() || family}`);
        if (type !== 'all') labels.push(`Type: ${typeButtons.find((button) => button.dataset.ozFilter === type)?.textContent.trim() || type}`);
        activeFilters.textContent = labels.join(' · ');
      }
    };

    const clearFilters = () => {
      if (input) input.value = '';
      family = 'all';
      type = 'all';
      selectFilter(familyButtons, family);
      selectFilter(typeButtons, type);
      update();
      input?.focus();
    };

    input?.addEventListener('input', update, { signal });
    familyButtons.forEach((button) => button.addEventListener('click', () => {
      family = button.dataset.ozFilter;
      selectFilter(familyButtons, family);
      update();
    }, { signal }));
    typeButtons.forEach((button) => button.addEventListener('click', () => {
      type = button.dataset.ozFilter;
      selectFilter(typeButtons, type);
      update();
    }, { signal }));
    clearButtons.forEach((button) => button.addEventListener('click', clearFilters, { signal }));

    hub.oztechResourceController = controller;
    update();
  };

  const initWithin = (root = document) => {
    if (root instanceof Element && root.matches(selector)) init(root);
    root.querySelectorAll?.(selector).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWithin(), { once: true });
  } else {
    initWithin();
  }

  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const hub = event.target.matches?.(selector) ? event.target : event.target.querySelector?.(selector);
    hub?.oztechResourceController?.abort();
    if (hub) delete hub.oztechResourceController;
  });
})();
